"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Levels = void 0;
exports.isLevel = isLevel;
exports.getLevelColor = getLevelColor;
// Textual proficiency levels aligned with backend API
// Keep export names stable for consumers (Levels, LevelCode, isLevel)
exports.Levels = [
    "BEGINNER",
    "ELEMENTARY",
    "INTERMEDIATE",
    "UPPER_INTERMEDIATE",
    "ADVANCED",
    "PROFICIENT",
];
function isLevel(code) {
    return !!code && exports.Levels.includes(code);
}
/**
 * Get standardized color for a difficulty level
 * Used across all applications for consistent level color scheme
 */
function getLevelColor(difficulty) {
    switch (difficulty) {
        case "BEGINNER":
        case "ELEMENTARY":
            return "#4CAF50"; // Green
        case "INTERMEDIATE":
        case "UPPER_INTERMEDIATE":
            return "#FF9800"; // Orange
        case "ADVANCED":
        case "PROFICIENT":
            return "#F44336"; // Red
        default:
            return "#757575"; // Gray fallback
    }
}
//# sourceMappingURL=levels.js.map